import {Controller, Post, Body, Res} from '@nestjs/common';
import {FastifyReply} from 'fastify';
import {ChatService} from './chat.service';

/**
 * 聊天与对话控制器
 * 负责响应三端的 AI 对话与流式响应请求
 */
@Controller('api/chat')
export class ChatController {
  constructor(private readonly chatService: ChatService) {}

  /**
   * 处理聊天对话补全与流式输出
   * @param body 包含大模型配置与用户提示词
   * @param reply Fastify 响应对象
   */
  @Post('completions')
  async handleChat(@Body() body: any, @Res() reply: FastifyReply) {
    const {settings, prompt} = body;

    reply.raw.setHeader('Content-Type', 'text/plain; charset=utf-8');
    reply.raw.setHeader('Transfer-Encoding', 'chunked');

    try {
      await this.chatService.streamChatCompletion(settings, prompt, chunk => {
        reply.raw.write(chunk);
      });
      reply.raw.end();
    } catch (err: any) {
      reply.raw.write(`\n[Server Error]: ${err.message}`);
      reply.raw.end();
    }
  }
}
